export var avatarStatusIconStyles = {
  root: function root(_ref) {
    var state = _ref.props.state,
        v = _ref.variables;
    return Object.assign({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: v.statusIconSize,
      height: v.statusIconSize,
      color: v.statusColor
    }, state === 'success' && {
      color: v.statusSuccessColor
    }, state === 'info' && {
      color: v.statusInfoColor
    }, state === 'error' && {
      color: v.statusErrorColor
    }, state === 'warning' && {
      color: v.statusWarningColor
    }, {
      '& > :first-child': {
        height: '100%',
        width: '100%',
        '& svg': {
          height: '100%',
          width: '100%'
        }
      }
    });
  }
};
//# sourceMappingURL=avatarStatusIconStyles.js.map
